<template>
  <div>
    <a-modal
      v-model="visible"
      :title="title"
      @ok="handleOk"
      @cancel="handleCancel"
      :footer="null"
      :maskClosable="false"
    >
      <div v-if="id == 3">
        <div style="margin-bottom: 10px">企业品牌(请先选择企业品牌)</div>
        <a-select
          show-search
          v-model="dataFrom.id"
          placeholder="请选择"
          option-filter-prop="children"
          :filter-option="filterOption"
          style="width: 100%"
        >
          <a-select-option v-for="d in userList" :key="d.id">{{ d.name }}</a-select-option>
        </a-select>
      </div>

      <div class="spin_p" v-if="(dataFrom.id && id == 3) || id !== 3">
        <div class="spin-content" v-if="loading">
          <a-spin tip="Loading..." size="large"> </a-spin>
        </div>
        <div class="file-h">
          文件：请现在下载模板文件，填写完成数据后再上传<a-button
type="link"
@click="handleDown"
            >下载模板文件</a-button
          >
        </div>
        <a-upload-dragger
          :headers="headers"
          name="file"
          :multiple="false"
          :before-upload="beforeUpload"
          @change="handleChange"
          :showUploadList="false"
          :accept="'.xls,.xlsx'"
          :data="dataFrom"
          :customRequest="customUpload"
        >
          <p class="ant-upload-drag-icon">
            <!-- <a-icon type="inbox" /> -->
            <a-icon type="cloud-upload" />
          </p>
          <p class="ant-upload-text">将文件拖到此处，或<a-button type="link">点击上传</a-button></p>
        </a-upload-dragger>
        <div class="strDate">
          {{ strDate }}
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
// import { projectpageinfo, addprojectpage, editprojectpage } from '@/api/Project'
// import { download, factoryImport, downloads } from '@/api/pressure/factory'
// import { pageTenant, frozenTenant } from '@/api/system/tenant'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { listTenant, importTenant, importData, importDev } from '@/api/system/tenant'

// import FileUpload from '@/components/FileUpload/index'
// import { exportExcel } from '@/util/export'
// import { baseUrl } from '@/config/env' // progress bar style
export default {
  // components: { FileUpload },
  data() {
    return {
      uploadImgUrl: process.env.VUE_APP_BASE_API + '/system/tenant/import',
      // url_: baseUrl + '/imgs/',
      loading: false,
      visible: false,
      url_: process.env.VUE_APP_BASE_API,
      title: '批量导入企业品牌',
      id: '',
      dataFrom: {},
      userList: [],
      strDate: '',
      headers: {
        Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN),
      },
    }
  },
  created() {
    // this.getQi()
  },
  methods: {
    changeImg(info) {
      console.log('info', info)
    },
    // 查询企业品牌
    getQi() {
      const query = {
        pageNum: 1,
        pageSize: 999,
        type: 1,
        status: 0,
      }
      listTenant(query).then((res) => {
        console.log(res, '的点点滴滴')
        this.userList = res.data.records
      })
    },
    // 点击关闭
    handleCancel() {
      console.log(1112)
      this.$emit('ok')
    },
    beforeUpload(file) {
      console.log(file, 'filefile')
      this.loading = true
      // if (!this.dataFrom.id) {
      //   this.$message.error('请先选择企业品牌')
      //   return false
      // }
      return true
    },
    customUpload(options) {
      const { file, onProgress, onSuccess, onError } = options

      // 创建FormData对象
      const formData = new FormData()
      formData.append('file', file)

      // 如果需要额外参数
      if (this.dataFrom) {
        Object.keys(this.dataFrom).forEach((key) => {
          formData.append(key, this.dataFrom[key])
        })
      }
      if (this.id == 1 || this.id == 2) {
        // 批量上传企业 或经销商
        importTenant(formData).then((res) => {
          console.log(res.code, 'resresres=====')
          if (res.code == '20001') {
            // this.$message.success('上传成功')
            // this.visible = false
            // this.loading = false
            // this.$emit('ok')
            this.loading = false
            this.strDate = res.data
          }
        })
      } else if (this.id == 3) {
        // 上传设备
        importDev(formData).then((res) => {
          console.log(res.code, 'resresres=====')
          if (res.code == '20001') {
            console.log(res, 'resresres=====111')
            this.loading = false
            this.strDate = res.data
            // this.$message.success('上传成功')
            // this.visible = false
            // this.loading = false
            // this.$emit('ok')
          } else {
            this.loading = false
          }
        })
      } else if (this.id == 4 || this.id == 5) {
        // 上传验收员和水工
        if (this.id == 4) {
          formData.append('roleCode', 'YSY00')
        } else {
          formData.append('roleCode', 'SG00')
        }
        importData(formData).then((res) => {
          console.log(res, 'resresres=====')
          if (res.code == '20001') {
            // this.$message.success('上传成功')
            // this.visible = false
            this.loading = false
            this.strDate = res.data
            // this.$emit('ok')
          } else {
            this.loading = false
          }
        })
      }

      // 使用axios或其他HTTP库进行上传
      // axios.post(this.uploadImgUrl, formData, {
      //   headers: {
      //     ...this.headers,
      //     'Content-Type': 'multipart/form-data'
      //   },
      //   onUploadProgress: ({ total, loaded }) => {
      //     onProgress({ percent: Math.round(loaded / total * 100) }, file);
      //   }
      // }).then(response => {
      //   onSuccess(response.data, file);
      // }).catch(error => {
      //   onError(error);
      // });
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleSuccess(e) {
      console.log(e, 'dddd对对对')
      if (e.code) {
        this.$message.error(e.msg)
        this.loading = false
      } else {
        this.$message.success('操作成功')
        this.visible = false
        this.loading = false
        this.$emit('refreshDataList')
      }
    },
    handleOk() {},
    handleChange(info) {
      if (info.file.status === 'done') {
        if (info.file.response.code !== '20001') {
          this.$message.error('上传失败' + info.file.response.message)
          this.loading = false
          return
        }
      }
    },
    handleBefore(e) {
      console.log(e, 1111)
      this.loading = true
    },
    // 点击下载模版
    handleDown() {
      if (this.id === 1) {
        this.download('system/tenant/export', {}, `企业品牌模版.xlsx`)
      } else if (this.id === 2) {
        this.download('system/tenant/export', {}, `经销商模版.xlsx`)
      } else if (this.id == 3) {
        this.download('fix/dev/export', {}, `设备模版.xlsx`)
      } else if (this.id == 4) {
        this.download('system/user/importTemplate', {}, `验收员.xlsx`)
      } else {
        this.download('system/user/importTemplate', {}, `水工.xlsx`)
      }
    },
    init(id) {
      // this.dataForm.id = id || ''
      // this.isAgent = isAgent
      console.log(id, '顶顶顶顶')
      this.strDate = ''
      this.id = id
      if (id === 1) {
        this.title = '批量导入企业品牌'
      } else if (id === 2) {
        this.title = '批量导入经销商'
      } else if (id === 3) {
        this.title = '批量导入设备'
        this.uploadImgUrl = this.url_ + '/fix/dev/import'
        this.getQi()
      } else if (id == 4) {
        this.title = '批量导入验收员'
        this.uploadImgUrl = this.url_ + '/system/user/importData'
      } else if (id == 5) {
        this.title = '批量导入水工'
        this.uploadImgUrl = this.url_ + '/system/user/importData'
      }
      this.visible = true
      console.log(this.visible, 'visiblevisiblevisible')
    },
  },
}
</script>
<style lang="less" scoped>
.file {
  text-align: center;
}

.file-h {
  margin-bottom: 20px;
  font-size: 14px;
  // display: flex;
  // align-items: center;
}
.spin_p {
  position: relative;
  .spin-content {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    border: 1px solid #91d5ff;
    background-color: #e6f7ff;
    padding: 30px;
    height: 200px;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.strDate {
  color: red;
}
</style>

